export default {
  title: 'Rabat på årskontrakt',
  buttons: {
    edit: 'Rediger rabat',
    save: 'Gem rabat',
  },
  toasts: {
    invalid_discount: 'Rabatten på årskontrakten skal være mellem {{min}}% og {{max}}%',
  },
};
